import React from 'react';
import { Switch } from 'react-router-dom';
import { home } from '../config';
import Route from './routes';
import SignIn from '../pages/SignIn';
import Sobre from '../pages/Sobre';
import SignInAdmin from '../pages/SignInAdmin';
import SignUp from '../pages/SignUp';
import RecoverPassword from '../pages/RecoverPassword';
import ResetPassword from '../pages/ResetPassword';
import Products from '../pages/Products';

import VideosDashboard from '../pages/VideosDashboard';
import DashboardPages from '../pages/DashboardPages';
import Student from '../pages/Student';
import Sale from '../pages/Sale';
import Course from '../pages/Course';
import Lesson from '../pages/Lesson';
import Home from '../pages/Home';
import AreaExposicao from '../pages/AreaExposicao';
import Expositor from '../pages/Expositor';
import Galeria from '../pages/Galeria';
import ExpositorChat from '../pages/ExpositorChat';
import SigninExpositor from '../pages/SigninExpositor';
import Program from '../pages/Program';
import ProductsAdmin from '../pages/ProductsAdmin';
import QuizzAdmin from '../pages/QuizzAdmin';
import SignUpVips from '../pages/SignupVips';
import CheckinQR from '../pages/CheckinQR';
import Certificados from '../pages/Certificados';

import SignupVips from '../pages/SignupVips';
import Termos from '../pages/Termos';
import Inscricao from '../pages/Inscricao';
import Profile from '../pages/Profile';
import ProfileList from '../pages/ProfileList';
import PaymentMethod from '../pages/Products/modules/PaymentMethod';
import PaymentConfirmation from '../pages/Products/modules/PaymentConfirmation';
import Poster from '../pages/Poster';
import TrabalhosNotificacao from '../pages/TrabalhosNotificacao';
const ValidPaths = {
  SignIn,
  SignInAdmin,
  SignUp,
  RecoverPassword,
  ResetPassword,
  Products,
  VideosDashboard,
  Student,
  Sale,
  Course,
  Lesson,
  Home,
  Sobre,
};

const Routes: React.FC = () => {
  return (
    <Switch>
      <Route
        path="/"
        exact
        component={ValidPaths[home] ? ValidPaths[home] : Home}
      />
      <Route path="/certificados" component={Certificados} />
      <Route path="/quizz" component={() => <QuizzAdmin room_id={2} />} />
      <Route path="/login" component={SignIn} />
      <Route isPrivate path="/exposicao" component={AreaExposicao} />
      <Route path="/checkin" isPrivate component={CheckinQR} />
      <Route path="/perfil" isPrivate component={Profile} />
      <Route path="/inscricao/:productId" component={() => <Products/> } />
      <Route path="/inscricao" component={Products} />
      <Route path="/trabalhos-cientificos" component={Poster} />
      <Route path="/checkout/:product_hash" component={PaymentMethod} />
      <Route path="/payment/success/:payment_hash" component={PaymentConfirmation} />

      <Route path="/cortesias" component={SignupVips} />
      <Route
        path="/checkin-restaurante"
        isPrivate
        component={() => (
          <CheckinQR room_id={15} title="Restaurante" accept_multiple={1} />
        )}
      />
      <Route path="/trabalhos-cientificos" component={TrabalhosNotificacao} />
      <Route path="/programacao" component={Sobre} />
      <Route path="/admin" component={SignInAdmin} />
      <Route path="/login_expositor" component={SigninExpositor} />
   
      <Route path="/termos" component={Termos} />
      <Route path="/associado" component={SignUp} />
      <Route path="/recuperar_senha" component={RecoverPassword} />
      <Route path="/reset_password/:key?" component={ResetPassword} />

      <Route
        path="/expositores/:link_name"
        template="page"
        component={ExpositorChat}
      />
      <Route path="/galeria/:link_name" template="page" component={Galeria} />
      <Route
        path="/expositores_chat/:link_name"
        template="page"
        component={ExpositorChat}
      />
      <Route
        path="/dashboard/:videoIdItem"
        isPrivate
        component={VideosDashboard}
      />
      <Route path="/dashboard" isPrivate component={VideosDashboard} />

      <Route
        path="/aulas"
        template="manager"
        isPrivate
        isSecret
        component={Lesson}
      />
      <Route
        path="/alunos"
        template="manager"
        isPrivate
        isSecret
        component={Student}
      />
 <Route
        path="/manager/:tab"
        template="manager"
        isPrivate
        isSecret
        component={DashboardPages}
      />
      <Route
        path="/manager"
        template="manager"
        isPrivate
        isSecret
        component={DashboardPages}
      />
      <Route
        path="/vendas"
        template="manager"
        isSecret
        isPrivate
        component={Sale}
      />
      <Route
        path="/produtos"
        template="manager"
        isSecret
        isPrivate
        component={ProductsAdmin}
      />
      <Route
        path="/cursos"
        template="manager"
        isSecret
        isPrivate
        component={Course}
      />
    </Switch>
  );
};

export default Routes;
